export default {"src":"/_next/static/media/icon_arrow_clockwise_circle.64a565d5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};